var _rect, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 69,
    viewBox: "0 0 70 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.132812,
    y: 0.222656,
    width: 69.678,
    height: 68.2264,
    fill: "url(#paint0_linear_46_5590)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.4288 27.5216H54.2455V43.4867H51.2526V27.5216H46.0819V24.9047H59.4288V27.5216ZM45.0381 43.4867H34.9129V24.9047H44.6369V27.5216H37.9057V32.7849H44.1077V35.3891H37.9057V40.8846H45.0381V43.4867ZM30.9498 43.4867H27.6776L19.0625 29.8282C18.847 29.4883 18.6655 29.1278 18.5206 28.7519H18.445C18.5122 29.1508 18.5459 30.0013 18.5459 31.3055V43.4867H15.6538V24.9047H19.1381L27.4655 38.2424C27.8162 38.7932 28.0431 39.1752 28.1439 39.382H28.1943C28.1103 38.8903 28.0683 38.0546 28.0683 36.8812V24.9026H30.9498V43.4867ZM12.6715 42.0242C12.6715 42.2541 12.6243 42.4818 12.5326 42.6942C12.4408 42.9066 12.3063 43.0995 12.1368 43.262C11.9673 43.4245 11.7661 43.5533 11.5447 43.6411C11.3233 43.7289 11.086 43.774 10.8464 43.7737C10.6068 43.7737 10.3696 43.7284 10.1483 43.6403C9.92698 43.5523 9.72591 43.4232 9.5566 43.2605C9.38729 43.0979 9.25306 42.9048 9.16157 42.6922C9.07009 42.4797 9.02315 42.252 9.02344 42.0221C9.02402 41.5585 9.21634 41.114 9.55816 40.7864C9.89997 40.4587 10.3633 40.2747 10.8464 40.2747C11.086 40.2744 11.3233 40.3195 11.5447 40.4073C11.7661 40.4951 11.9673 40.6239 12.1368 40.7864C12.3063 40.9489 12.4408 41.1418 12.5326 41.3542C12.6243 41.5666 12.6715 41.7943 12.6715 42.0242Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_46_5590",
    x1: 34.9718,
    y1: 0.222656,
    x2: 34.9718,
    y2: 68.4491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F36F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922994"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNet);
export default __webpack_public_path__ + "static/media/net.5881ff47f33b88a0eb75006f26bd62eb.svg";
export { ForwardRef as ReactComponent };